import { render, staticRenderFns } from "./LabelDelete.vue?vue&type=template&id=65b99308&"
import script from "./LabelDelete.vue?vue&type=script&lang=js&"
export * from "./LabelDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports